import { render, staticRenderFns } from "./CustomerBasic.vue?vue&type=template&id=5a106892&scoped=true&"
import script from "./CustomerBasic.vue?vue&type=script&lang=js&"
export * from "./CustomerBasic.vue?vue&type=script&lang=js&"
import style0 from "./CustomerBasic.vue?vue&type=style&index=0&id=5a106892&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a106892",
  null
  
)

export default component.exports